module.exports = __webpack_public_path__ + "assets/images/globo_c968963997ea7ebe8c65e8d74682703b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yellow/esfera/globo.png
// module id = 204
// module chunks = 0